import React from 'react';
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';

const UnauthorizedModal = ({ show, onClose }) => {
    return (
        <Dialog
            sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435 } }}
            maxWidth="xs"
            open={show}
        >
            <DialogTitle py={3}>
                <Typography variant='h4' sx={{ color : (theme) => theme.palette.error.main}}>Non Autorisé</Typography>
            </DialogTitle>

            <DialogContent dividers>
                <Alert variant="outlined" severity="error">vous n'êtes pas autorisé à effectuer cette action.</Alert>
            </DialogContent>

            <DialogActions>
                <Button autoFocus onClick={onClose}>
                    Ok
                </Button>
            </DialogActions>

        </Dialog>
    );
};

export default UnauthorizedModal;